import { useSelector } from 'react-redux';
import { useGetSystemSettingsQuery } from '@/store/api/settingsApi';
import { selectStoreAndOutlet } from '@/store/slices/storeSlice';
import type { SystemSettings } from '@/store/api/settingsApi';

export interface UseSettingsReturn {
  settings: SystemSettings | undefined;
  isLoading: boolean;
  error: any;
  refetch: () => void;
}

export const useSettings = (): UseSettingsReturn => {
  const { outletId, storeId } = useSelector(selectStoreAndOutlet);

  const {
    data: settingsData,
    isLoading,
    error,
    refetch,
  } = useGetSystemSettingsQuery(
    { storeId: storeId || "", outletId: outletId || "" },
    {
      skip: !storeId,
      refetchOnMountOrArgChange: true,
      refetchOnReconnect: true,
    }
  );

  return {
    settings: settingsData?.data,
    isLoading,
    error,
    refetch,
  };
};

export default useSettings;
